export default {
  title: "Linehaul Dates",
  starting_date: "Starting date",
  ending_date: "Ending date",
  edit: "Edit",
  not_especified: "--",
  clear: "Clear",
};
